import { useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, ChevronRight, Quote, Send } from 'lucide-react'
import { InnerHero } from '@/components/sections'
import { Prefooter, Footer } from '@/components/layout'

type Showcase = { name: string; city: string }

const showcase: Showcase[] = [
  { name: 'Sereni Hair', city: 'Pisa' },
  { name: 'Ornella Zavaglia', city: 'Marina di Gioiosa' },
  { name: 'Elis Hair', city: 'Giussano' },
  { name: 'Cris Line Parrucchieri', city: 'Cusano Milanino' },
]

type Pillar = { n: string; label: string; body: string }

const pillars: Pillar[] = [
  {
    n: '01',
    label: 'Proposta semplice',
    body:
      'Offriamo prodotti professionali pensati per soddisfare le esigenze di chiunque voglia mettere al primo posto la voglia di semplicità e risultati professionali. I nostri trattamenti sono studiati per garantire risultati ottimali, rispettando la salute e la bellezza naturale dei capelli.',
  },
  {
    n: '02',
    label: 'Non vendiamo online',
    body:
      'Crediamo che il rapporto umano che si crea tra il professionista e le clienti sia una parte irrinunciabile dell’esperienza Nashi Argan.',
  },
  {
    n: '03',
    label: 'Supporto digital, visual e marketing',
    body:
      'Ci occupiamo di ogni aspetto della tua strategia di vendita: dal piano marketing alla creazione di supporti visual pensati su misura per il tuo salone. Con una comunicazione multi-canale, informiamo le tue clienti sulle promozioni in corso e le coinvolgiamo direttamente tramite i social, spingendole a visitare il salone.',
  },
  {
    n: '04',
    label: 'Formazione specializzata',
    body:
      'Offriamo corsi completi per professionisti del settore, che uniscono formazione tecnica, pratica e strategie di vendita. Inoltre, Nashi ha creato la prima Social School, un programma pensato per formare i parrucchieri sulle migliori tecniche social, aiutandoli a sfruttare al meglio le potenzialità digitali per promuovere il loro salone e attrarre nuovi clienti.',
  },
]

type Testimonial = { city: string; salon: string; quote: string }

const testimonials: Testimonial[] = [
  {
    city: 'Napoli',
    salon: 'Fashion Point',
    quote:
      'Ho scelto Nashi Argan come partner perché è semplice, trasparente, presente e professionale. Ci stimola come Salone con un concept innovativo e le clienti vanno pazze per la sua profumazione inebriante e accattivante.',
  },
  {
    city: 'Napoli',
    salon: 'Izzo Luxury Salon',
    quote:
      'Consiglierei Nashi Argan in primo luogo perché oggi poche aziende sul mercato riescono a dare supporto al parrucchiere con un servizio clienti eccezionale come quello offerto da Nashi Argan. Secondariamente perché Nashi Argan offre prodotti che piacciono moltissimo anche alla consumatrice finale, a differenza di altre aziende che si concentrano esclusivamente sull’assecondare le necessità del parrucchiere.',
  },
  {
    city: 'Porto Viro',
    salon: 'SD Hair Atelier',
    quote:
      'L’evento del Nashi On Tour è stata un’occasione unica per il nostro Salone. Grazie a questo evento abbiamo acquisito nuove clienti che oggi scelgono il nostro Salone pur vivendo distanti. Inoltre la presenza in quei giorni dell’esperta Nashi Girl ha dato modo alle nostre clienti di ricevere una consulenza beauty personalizzata e conoscere tutti i segreti di bellezza dei loro prodotti Nashi Argan preferiti. Una formula vincente mai vista prima!',
  },
  {
    city: 'Gravina di Catania',
    salon: 'Michela Fareri Hair Spa By Nashi',
    quote:
      'All’interno del nostro salone le clienti vivono un’esperienza unica, hanno la possibilità di testare i prodotti e apprezzare la loro profumazione unica! L’azienda ci mette a disposizione tutto l’occorrente ogni mese per curare la presenza digitale del salone e organizzare eventi per le nostre bellissime Nashi Lovers.',
  },
  {
    city: 'Marina di Gioiosa Ionica',
    salon: 'Parrucchiera Ornella Zavaglia',
    quote:
      'Per noi essere partner Nashi Argan significa poter offrire e regalare una nuova customer experience, mantenendo le promesse alle nostre clienti. Dall’apertura dello store abbiamo avuto il piacere di notare che le clienti, dopo l’appuntamento in Salone, si soffermano nell’area store e sono loro stesse a chiedere di poterli acquistare per continuare l’esperienza anche a casa. Per noi questo è una conferma di aver fatto la scelta giusta!',
  },
  {
    city: 'Cosenza',
    salon: 'Bilotti 44 Hair Salon By Nashi',
    quote:
      'Siamo entrati a far parte della famiglia Nashi Argan cinque anni fa, quando abbiamo trasformato il salone di Castrolibero in un salone Total Nashi. Da quel momento in poi abbiamo abbracciato completamente la filosofia del brand. Abbiamo scelto di avviare il progetto By Nashi per l’attenzione che Nashi Argan pone sull’esperienza della cliente che è protagonista assoluta. Inoltre apprezziamo molto la scelta di non vendere online: per noi è importantissimo potersi legare ad un brand che valorizza il nostro impegno e il rapporto diretto che stabiliamo con le nostre clienti.',
  },
  {
    city: 'Bologna',
    salon: 'Mz Parrucchieri',
    quote:
      'Ho scelto per i tre saloni MZ PARRUCCHIERI di avere come partner Nashi Argan perché attraverso i prodotti e la filosofia nasce la bellezza su misura per ogni persona. I nostri saloni sono location dove le persone si immergono nell’esperienza Nashi Argan e possono scoprire come esaltare la loro bellezza grazie a prodotti professionali di altissima qualità. Chi viene da noi desidera un’esperienza speciale perché su misura per la sua personalità, i suoi capelli e necessità.',
  },
]

const COUNTRIES = [
  'Italia',
  'Francia',
  'Germania',
  'Spagna',
  'Svizzera',
  'Austria',
  'Belgio',
  'Paesi Bassi',
  'Portogallo',
  'Regno Unito',
  'Stati Uniti',
  'Canada',
  'Altro',
] as const

type FormState = {
  fullname: string
  email: string
  phone: string
  address: string
  city: string
  region: string
  postal: string
  country: string
  privacy: boolean
}

export function DiventaPartnerPage() {
  const [form, setForm] = useState<FormState>({
    fullname: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    region: '',
    postal: '',
    country: '',
    privacy: false,
  })
  const [submitted, setSubmitted] = useState(false)
  const [activeTestimonial, setActiveTestimonial] = useState(0)

  const update = <K extends keyof FormState>(key: K, value: FormState[K]) =>
    setForm((s) => ({ ...s, [key]: value }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (
      !form.fullname.trim() ||
      !form.email.trim() ||
      !form.phone.trim() ||
      !form.privacy
    ) {
      return
    }
    setSubmitted(true)
  }

  const featured = testimonials[activeTestimonial]

  return (
    <main className="bg-cream">
      <InnerHero
        eyebrow="Professionisti"
        title="Vuoi diventare un"
        titleItalic="Salone Nashi?"
        body="Vuoi ottenere maggiore visibilità per il tuo Salone ed essere costantemente supportato da un team di esperti in prodotti, marketing, vendita e formazione? Se ti ritrovi nella nostra filosofia, scegli la qualità garantita di Nashi Argan."
        breadcrumbs={[{ label: 'Home', href: '/it' }, { label: 'Diventa Partner' }]}
      />

      {/* ───────── CTA Anchor below hero ───────── */}
      <section className="relative bg-cream pt-2 pb-14 md:pb-20">
        <div className="nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.8 }}
            className="-mt-8 md:-mt-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
          >
            <a
              href="#diventa-partner-form"
              className="group inline-flex items-center gap-3 self-start bg-bruno text-cream font-medium uppercase tracking-[0.28em] text-[11px] px-9 py-4 hover:bg-argan-deep transition-colors"
            >
              Diventa un Salone Partner
              <ArrowRight
                className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1"
                strokeWidth={1.75}
              />
            </a>
            <p className="max-w-md text-[12px] uppercase tracking-[0.28em] text-bruno-muted">
              Una rete di Saloni Partner in tutta Italia. Quattro storie, una sola filosofia.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ───────── Showcase strip ───────── */}
      <section className="relative bg-cream-soft py-16 md:py-20 border-y border-bruno/10 overflow-hidden">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-8 left-[-3%] select-none font-display italic text-argan/[0.06]"
          style={{ fontSize: 'clamp(10rem, 22vw, 22rem)', lineHeight: 0.85 }}
        >
          §
        </div>
        <div className="relative nashi-container">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-bruno/10 border border-bruno/10">
            {showcase.map((s, i) => (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.85, delay: i * 0.08 }}
                className="bg-cream-soft px-6 py-10 md:px-8 md:py-14 flex flex-col gap-3 group hover:bg-cream transition-colors duration-700"
              >
                <span className="text-[10px] uppercase tracking-[0.32em] text-bruno-muted">
                  {String(i + 1).padStart(2, '0')}. Partner
                </span>
                <p
                  className="font-display italic text-bruno"
                  style={{
                    fontSize: 'clamp(1.25rem, 1.8vw, 1.625rem)',
                    lineHeight: 1.1,
                    letterSpacing: '-0.005em',
                  }}
                >
                  {s.name}
                </p>
                <span className="text-[12px] uppercase tracking-[0.28em] text-argan-deep">
                  — {s.city}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ───────── Manifesto ───────── */}
      <section className="relative bg-cream py-20 md:py-28 overflow-hidden">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute top-[-6%] right-[-3%] select-none font-display italic text-argan/[0.05]"
          style={{ fontSize: 'clamp(12rem, 26vw, 26rem)', lineHeight: 0.85 }}
        >
          &
        </div>
        <div className="relative nashi-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9 }}
              className="lg:col-span-5"
            >
              <span className="nashi-eyebrow">— Perché sceglierci?</span>
              <h2
                className="mt-6 font-display text-bruno"
                style={{
                  fontSize: 'clamp(2rem, 3.6vw, 3rem)',
                  lineHeight: 1.02,
                  letterSpacing: '-0.015em',
                }}
              >
                <span className="block">Essere Nashi Partner:</span>
                <span className="block italic font-light text-argan-deep">
                  più valore al tuo Salone,
                </span>
                <span className="block italic font-light text-argan-deep">
                  più bellezza per le tue clienti.
                </span>
              </h2>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: 0.15 }}
              className="lg:col-span-7 lg:pt-10"
            >
              <p className="text-bruno-soft text-base md:text-lg leading-[1.75]">
                Una proposta su misura per il professionista che cerca semplicità,
                risultati e una relazione vera con le proprie clienti. Quattro pilastri,
                un solo modo di intendere il mestiere.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ───────── Pillars 2x2 ───────── */}
      <section className="relative bg-cream-soft py-20 md:py-28 overflow-hidden border-y border-bruno/10">
        <div className="nashi-container">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-bruno/10 border border-bruno/10">
            {pillars.map((p, i) => (
              <motion.div
                key={p.n}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.95, delay: (i % 2) * 0.1 }}
                className="bg-cream-soft p-10 md:p-14 flex flex-col gap-6 group hover:bg-cream transition-colors duration-700"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-display italic text-argan-deep tabular-nums text-5xl md:text-6xl">
                    {p.n}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.32em] text-bruno-muted">
                    Pilastro
                  </span>
                </div>
                <h3
                  className="font-display text-bruno"
                  style={{
                    fontSize: 'clamp(1.5rem, 2.2vw, 2rem)',
                    lineHeight: 1.1,
                    letterSpacing: '-0.005em',
                  }}
                >
                  {p.label}
                </h3>
                <div
                  aria-hidden="true"
                  className="h-px w-12 bg-argan/40 group-hover:w-20 transition-all duration-700"
                />
                <p className="text-bruno-soft text-[15px] md:text-[16px] leading-[1.8]">
                  {p.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ───────── Testimonials — featured + ledger ───────── */}
      <section className="relative bg-cream py-20 md:py-32 overflow-hidden">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute top-[8%] right-[-4%] select-none font-display italic text-argan/[0.05]"
          style={{ fontSize: 'clamp(12rem, 26vw, 26rem)', lineHeight: 0.85 }}
        >
          ”
        </div>

        <div className="relative nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
            className="max-w-3xl mb-16 md:mb-20"
          >
            <span className="nashi-eyebrow">— Voci dei partner</span>
            <h2
              className="mt-6 font-display text-bruno"
              style={{
                fontSize: 'clamp(2rem, 3.6vw, 3rem)',
                lineHeight: 1.02,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="block">La parola a chi</span>
              <span className="block italic font-light text-argan-deep">
                questa scelta l’ha già fatta.
              </span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            {/* Featured quote */}
            <motion.figure
              key={featured.salon}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.9 }}
              className="lg:col-span-7 relative bg-cream-soft border border-bruno/10 p-10 md:p-14"
            >
              <Quote
                className="absolute -top-5 left-10 text-argan-deep h-10 w-10 bg-cream-soft px-1"
                strokeWidth={1.25}
              />
              <span className="block text-[10px] uppercase tracking-[0.32em] text-bruno-muted">
                — {featured.city}
              </span>
              <p className="mt-2 font-display italic text-argan-deep text-xl md:text-2xl">
                {featured.salon}
              </p>
              <blockquote
                className="mt-8 font-display text-bruno"
                style={{
                  fontSize: 'clamp(1.125rem, 1.6vw, 1.5rem)',
                  lineHeight: 1.45,
                  letterSpacing: '-0.005em',
                }}
              >
                <span className="text-argan-deep italic">“</span>
                {featured.quote}
                <span className="text-argan-deep italic">”</span>
              </blockquote>
              <figcaption className="mt-10 flex items-center gap-3 text-[10px] uppercase tracking-[0.32em] text-bruno-muted">
                <span className="block w-6 h-px bg-argan-deep" />
                Salone Partner
              </figcaption>
            </motion.figure>

            {/* Selectable ledger of all testimonials */}
            <ol className="lg:col-span-5 flex flex-col">
              {testimonials.map((t, i) => {
                const active = i === activeTestimonial
                return (
                  <li key={`${t.salon}-${i}`} className="border-b border-bruno/10 last:border-b-0">
                    <button
                      onClick={() => setActiveTestimonial(i)}
                      className={[
                        'group w-full flex items-center justify-between gap-4 py-5 md:py-6 text-left transition-colors',
                        active ? 'text-bruno' : 'text-bruno-soft hover:text-bruno',
                      ].join(' ')}
                    >
                      <div className="flex items-baseline gap-5">
                        <span
                          className={[
                            'font-display italic tabular-nums text-2xl md:text-3xl transition-colors',
                            active ? 'text-argan-deep' : 'text-bruno-muted',
                          ].join(' ')}
                        >
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        <div>
                          <span className="block text-[10px] uppercase tracking-[0.32em] text-bruno-muted">
                            — {t.city}
                          </span>
                          <span
                            className={[
                              'block font-display mt-1 transition-colors',
                              active ? 'italic text-argan-deep' : 'text-bruno',
                            ].join(' ')}
                            style={{
                              fontSize: 'clamp(1.125rem, 1.4vw, 1.375rem)',
                              lineHeight: 1.15,
                            }}
                          >
                            {t.salon}
                          </span>
                        </div>
                      </div>
                      <ChevronRight
                        className={[
                          'h-4 w-4 shrink-0 transition-all duration-500',
                          active
                            ? 'text-argan-deep translate-x-0'
                            : 'text-bruno-muted group-hover:translate-x-1',
                        ].join(' ')}
                        strokeWidth={1.5}
                      />
                    </button>
                  </li>
                )
              })}
            </ol>
          </div>
        </div>
      </section>

      {/* ───────── Two-CTAs: Salone Partner / Nashi Salon ───────── */}
      <section className="relative bg-cream-soft py-20 md:py-28 overflow-hidden border-y border-bruno/10">
        <div className="nashi-container">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
            className="max-w-2xl mb-14 md:mb-16"
          >
            <span className="nashi-eyebrow">— Come collaborare?</span>
            <h2
              className="mt-6 font-display text-bruno"
              style={{
                fontSize: 'clamp(2rem, 3.6vw, 3rem)',
                lineHeight: 1.02,
                letterSpacing: '-0.015em',
              }}
            >
              <span className="block">Due strade,</span>
              <span className="block italic font-light text-argan-deep">
                un’unica filosofia.
              </span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-bruno/15 border border-bruno/15">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9 }}
              className="bg-cream p-10 md:p-14 flex flex-col gap-6 group"
            >
              <span className="text-[10px] uppercase tracking-[0.32em] text-argan-deep">
                01. Salone Partner
              </span>
              <h3
                className="font-display text-bruno"
                style={{
                  fontSize: 'clamp(1.75rem, 2.8vw, 2.5rem)',
                  lineHeight: 1.05,
                  letterSpacing: '-0.01em',
                }}
              >
                <span className="block">L’esperienza Nashi Argan</span>
                <span className="block italic font-light text-argan-deep">
                  nel tuo Salone.
                </span>
              </h3>
              <p className="text-bruno-soft text-[15px] leading-[1.75] max-w-md">
                Porta la nostra filosofia tra le tue mani. Mantieni la tua insegna e diventa
                un riferimento Nashi nella tua zona, con prodotti, formazione e supporto
                marketing.
              </p>
              <a
                href="#diventa-partner-form"
                className="mt-2 inline-flex items-center gap-3 self-start bg-bruno text-cream font-medium uppercase tracking-[0.28em] text-[11px] px-9 py-4 hover:bg-argan-deep transition-colors"
              >
                Salone Partner
                <ArrowRight
                  className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1"
                  strokeWidth={1.75}
                />
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="bg-bruno text-cream p-10 md:p-14 flex flex-col gap-6 group"
            >
              <span className="text-[10px] uppercase tracking-[0.32em] text-argan-soft">
                02. Nashi Salon
              </span>
              <h3
                className="font-display text-cream"
                style={{
                  fontSize: 'clamp(1.75rem, 2.8vw, 2.5rem)',
                  lineHeight: 1.05,
                  letterSpacing: '-0.01em',
                }}
              >
                <span className="block">Sei un imprenditore</span>
                <span className="block italic font-light text-argan-soft">
                  e vuoi aprire un tuo salone?
                </span>
              </h3>
              <p className="text-cream/80 text-[15px] leading-[1.75] max-w-md">
                Apri un Nashi Salon: format esclusivo, identità totalmente Nashi e
                accompagnamento end-to-end dall’apertura al lancio commerciale.
              </p>
              <a
                href="#diventa-partner-form"
                className="mt-2 inline-flex items-center gap-3 self-start bg-cream text-bruno font-medium uppercase tracking-[0.28em] text-[11px] px-9 py-4 hover:bg-argan-soft transition-colors"
              >
                Apri il tuo Salone
                <ArrowRight
                  className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1"
                  strokeWidth={1.75}
                />
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ───────── Form ───────── */}
      <section
        id="diventa-partner-form"
        className="relative bg-cream py-24 md:py-32 overflow-hidden scroll-mt-32"
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute bottom-[-8%] left-[-5%] select-none font-display italic text-argan/[0.05]"
          style={{ fontSize: 'clamp(14rem, 30vw, 30rem)', lineHeight: 0.85 }}
        >
          d.
        </div>

        <div className="relative nashi-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
            <motion.aside
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9 }}
              className="lg:col-span-4 lg:sticky lg:top-32"
            >
              <span className="nashi-eyebrow">— Richiedi informazioni</span>
              <h2
                className="mt-6 font-display text-bruno"
                style={{
                  fontSize: 'clamp(2rem, 3.6vw, 3rem)',
                  lineHeight: 1,
                  letterSpacing: '-0.015em',
                }}
              >
                <span className="block">Diventa un</span>
                <span className="block italic font-light text-argan-deep">
                  Salone Partner.
                </span>
              </h2>
              <p className="mt-8 text-bruno-soft text-[15px] leading-[1.8] max-w-sm">
                Compila il form: ti contatteremo nel più breve tempo possibile per
                presentarti la collaborazione e il piano di onboarding pensato per il tuo
                Salone.
              </p>
              <ul className="mt-10 space-y-4 text-[12px] uppercase tracking-[0.28em] text-bruno-muted">
                <li className="flex items-center gap-3">
                  <span className="block w-5 h-px bg-argan-deep" />
                  Risposta entro 48h
                </li>
                <li className="flex items-center gap-3">
                  <span className="block w-5 h-px bg-argan-deep" />
                  Consulenza gratuita
                </li>
                <li className="flex items-center gap-3">
                  <span className="block w-5 h-px bg-argan-deep" />
                  Senza impegno
                </li>
              </ul>
            </motion.aside>

            <div className="lg:col-span-8">
              {submitted ? (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.9, ease: [0.25, 1, 0.5, 1] }}
                  className="bg-cream-soft border border-bruno/10 px-8 py-14 md:px-14 md:py-20 text-center"
                >
                  <span className="font-display italic text-argan-deep text-sm tracking-[0.32em] uppercase">
                    Grazie
                  </span>
                  <h3
                    className="mt-6 font-display text-bruno"
                    style={{
                      fontSize: 'clamp(2rem, 3.5vw, 3rem)',
                      lineHeight: 1.05,
                      letterSpacing: '-0.02em',
                    }}
                  >
                    <span className="block">La tua richiesta</span>
                    <span className="block italic font-light text-argan-deep">
                      è stata inviata.
                    </span>
                  </h3>
                  <p className="mt-6 max-w-md mx-auto text-bruno-soft leading-relaxed">
                    Un consulente Nashi Argan ti contatterà nel più breve tempo possibile.
                    Nel frattempo, scopri il mondo dei nostri saloni partner.
                  </p>
                </motion.div>
              ) : (
                <motion.form
                  onSubmit={handleSubmit}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.15 }}
                  transition={{ duration: 0.9 }}
                  className="space-y-8"
                  noValidate
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Field label="Nome & Cognome" required htmlFor="dp-name">
                      <input
                        id="dp-name"
                        type="text"
                        required
                        value={form.fullname}
                        onChange={(e) => update('fullname', e.target.value)}
                        placeholder="Nome & Cognome"
                        className="nashi-input"
                        autoComplete="name"
                      />
                    </Field>
                    <Field label="Email" required htmlFor="dp-email">
                      <input
                        id="dp-email"
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => update('email', e.target.value)}
                        placeholder="Email"
                        className="nashi-input"
                        autoComplete="email"
                      />
                    </Field>
                  </div>

                  <Field label="Numero di telefono" required htmlFor="dp-phone">
                    <input
                      id="dp-phone"
                      type="tel"
                      required
                      value={form.phone}
                      onChange={(e) => update('phone', e.target.value)}
                      placeholder="Numero di telefono"
                      className="nashi-input"
                      autoComplete="tel"
                    />
                  </Field>

                  <fieldset className="space-y-6 pt-4">
                    <legend className="block text-[10px] uppercase tracking-[0.32em] text-bruno-muted mb-2">
                      Indirizzo del Salone
                    </legend>

                    <Field label="Indirizzo (linea 1)" htmlFor="dp-address">
                      <input
                        id="dp-address"
                        type="text"
                        value={form.address}
                        onChange={(e) => update('address', e.target.value)}
                        placeholder="Via, numero civico"
                        className="nashi-input"
                        autoComplete="address-line1"
                      />
                    </Field>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Field label="Città" htmlFor="dp-city">
                        <input
                          id="dp-city"
                          type="text"
                          value={form.city}
                          onChange={(e) => update('city', e.target.value)}
                          placeholder="Città"
                          className="nashi-input"
                          autoComplete="address-level2"
                        />
                      </Field>
                      <Field label="Stato / Provincia / Regione" htmlFor="dp-region">
                        <input
                          id="dp-region"
                          type="text"
                          value={form.region}
                          onChange={(e) => update('region', e.target.value)}
                          placeholder="Provincia / Regione"
                          className="nashi-input"
                          autoComplete="address-level1"
                        />
                      </Field>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Field label="Codice postale" htmlFor="dp-postal">
                        <input
                          id="dp-postal"
                          type="text"
                          value={form.postal}
                          onChange={(e) => update('postal', e.target.value)}
                          placeholder="CAP"
                          className="nashi-input"
                          autoComplete="postal-code"
                        />
                      </Field>
                      <Field label="Nazione" htmlFor="dp-country">
                        <div className="relative">
                          <select
                            id="dp-country"
                            value={form.country}
                            onChange={(e) => update('country', e.target.value)}
                            className="nashi-input appearance-none pr-10 cursor-pointer"
                          >
                            <option value="" disabled>
                              Seleziona country
                            </option>
                            {COUNTRIES.map((c) => (
                              <option key={c} value={c}>
                                {c}
                              </option>
                            ))}
                          </select>
                          <span
                            aria-hidden="true"
                            className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-bruno-muted"
                          >
                            ↓
                          </span>
                        </div>
                      </Field>
                    </div>
                  </fieldset>

                  <label className="flex items-start gap-3 cursor-pointer pt-2">
                    <input
                      type="checkbox"
                      required
                      checked={form.privacy}
                      onChange={(e) => update('privacy', e.target.checked)}
                      className="mt-1 accent-bruno w-3.5 h-3.5 shrink-0"
                    />
                    <span className="text-[12px] leading-relaxed text-bruno-soft">
                      Letta l’informativa sulla{' '}
                      <a
                        href="/it/privacy-policy"
                        className="underline underline-offset-2 hover:text-argan-deep transition-colors"
                      >
                        Privacy Policy
                      </a>
                      , autorizzo il trattamento dei miei dati personali. Acconsento al
                      trattamento dei miei dati personali per ricevere newsletter e
                      comunicazioni promozionali da Nashi Argan.{' '}
                      <span className="text-argan-deep">*</span>
                    </span>
                  </label>

                  <div className="pt-4">
                    <button
                      type="submit"
                      className="group inline-flex items-center gap-3 bg-bruno text-cream font-medium uppercase tracking-[0.28em] text-[11px] px-10 py-4 hover:bg-argan-deep transition-colors"
                    >
                      Invia la tua richiesta
                      <Send
                        className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-0.5"
                        strokeWidth={1.75}
                      />
                    </button>
                  </div>

                  <p className="text-[10px] uppercase tracking-[0.28em] text-bruno-muted">
                    I campi con <span className="text-argan-deep">*</span> sono obbligatori
                  </p>
                </motion.form>
              )}
            </div>
          </div>
        </div>
      </section>

      <Prefooter />
      <Footer />
    </main>
  )
}

function Field({
  label,
  htmlFor,
  required,
  children,
}: {
  label: string
  htmlFor: string
  required?: boolean
  children: React.ReactNode
}) {
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="block text-[10px] uppercase tracking-[0.32em] text-bruno-muted mb-3"
      >
        {label}
        {required && <span className="text-argan-deep ml-1">*</span>}
      </label>
      {children}
    </div>
  )
}
